import BaseController from "../../controller/BaseController";
import AdminDataService from "../../util/AdminDataService";
import JSONModel from "sap/ui/model/json/JSONModel";
import { Button$PressEvent } from "sap/m/Button";
import { Dialog$AfterCloseEvent } from "sap/m/Dialog";
import SelectDialog from "sap/m/SelectDialog";
import StandardListItem from "sap/m/StandardListItem";
import DataService from "../../util/DataService";
import Validator from "../../util/Validator";
import Filter from "sap/ui/model/Filter";
import FilterOperator from "sap/ui/model/FilterOperator";

/**
 * @namespace com.reply.leaviosa.controller
 */
export default class DepartmentsController extends BaseController {
    private readonly DIALOG_ID = "DialogCreateUpdateDepartment";
    private _oSelectDialog: SelectDialog;

    public async onInit(): Promise<void> {
        AdminDataService.getDepartments();
        DataService.getUsers();
    }


    //*************************************************************************************
    // EVENT HANDLERS
    //*************************************************************************************

    public async onCreateDepartment(): Promise<void> {
        this.getView().setModel(new JSONModel({
            "edit": false
        }), "department");
        await this.openDialog(this.DIALOG_ID);
    }

    public async onEdit(oEvent: Button$PressEvent): Promise<void> {
        const selectedDepartment = oEvent.getSource().getBindingContext("dataModel").getObject();
        const department = {
            "edit": true,
            ...selectedDepartment
        }
        this.getView().setModel(new JSONModel(department), "department");
        await this.openDialog(this.DIALOG_ID);
    }

    public async onSaveDialog(oEvent: Dialog$AfterCloseEvent): Promise<void> {

        const validator = new Validator();
        const valid = validator.validate(oEvent.getSource().getParent());
        if (!valid) return;

        const departmentData = (this.getView().getModel("department") as JSONModel).getData();

        if (departmentData.id) {
            await AdminDataService.updateDepartment(departmentData);
        } else {
            await AdminDataService.createDepartment(departmentData);
        }
        AdminDataService.getDepartments();

        this.destroyDialog(this.DIALOG_ID);
    }

    onCloseDialog(oEvent: Dialog$AfterCloseEvent): void {
        AdminDataService.getDepartments();
        this.destroyDialog(this.DIALOG_ID);
    }

    onNavigateDepartment(oEvent: Button$PressEvent): void {
        const currentDepartment = oEvent.getSource().getBindingContext("dataModel").getObject() as any;
        this.navTo("department", {
            id: currentDepartment.id
        });
    }

    async onAddManager(oEvent: Button$PressEvent): Promise<void> {

        AdminDataService.getUsersInGroup("MANAGERS");

        if (!this._oSelectDialog) {
            this._oSelectDialog = new SelectDialog({
                title: "Select Manager",
                multiSelect: false,
                items: {
                    path: "dataModel>/MANAGERS",
                    template: new StandardListItem({
                        title: "{dataModel>firstName} {dataModel>lastName}",
                        description: "{dataModel>email}"
                    })
                },
                confirm: this.onManagerSelected.bind(this),
                search: this.onSearchManager.bind(this)
            });

            this.getView().addDependent(this._oSelectDialog);
        }

        this._oSelectDialog.open("");
    }

    private onSearchManager(oEvent: any): void {
        const sQuery = oEvent.getParameter("value");
        const aFilters = [];

        if (sQuery && sQuery.length > 0) {
            aFilters.push(new Filter({
                filters: [
                    new Filter("firstName", FilterOperator.Contains, sQuery),
                    new Filter("lastName", FilterOperator.Contains, sQuery),
                    new Filter("email", FilterOperator.Contains, sQuery)
                ],
                and: false
            }));
        }

        const oBinding = this._oSelectDialog.getBinding("items");
        oBinding.filter(aFilters);
    }

    private async onManagerSelected(oEvent: any): Promise<void> {
        const selectedItem = oEvent.getParameter("selectedItem");
        const departmentModel = this.getView().getModel("department") as JSONModel;
        const departmentData = departmentModel.getData();
        const selectedUser = selectedItem.getBindingContext("dataModel").getObject();
        let response;

        if (selectedItem) {
            response = await this.getClient().models.DepartmentManager.create({
                userId: selectedUser.userId,
                departmentId: departmentData.id
            })
        }

        const newDepartmentManager = {
            id: response.data.id,
            userId: selectedUser.userId,
            user: {
                id: selectedUser.userId,
                firstName: selectedUser.firstName,
                lastName: selectedUser.lastName,
                email: selectedUser.email
            }
        };
        departmentData.managers.push(newDepartmentManager);
        departmentModel.setData(departmentData);

    }

    private async onRemoveManager(oEvent: Button$PressEvent): Promise<void> {
        const manager = oEvent.getSource().getBindingContext("department").getObject();
        const departmentModel = this.getView().getModel("department") as JSONModel;
        const departmentData = departmentModel.getData();

        departmentData.managers = departmentData.managers.filter((lead: any) => lead.id !== manager.id);
        departmentModel.setData(departmentData);

        const { data, errors } = await this.getClient().models.DepartmentManager.delete({
            id: manager.id
        })
    }

}
